import {
    GET_WEEKDAY_WEEKEND_BY_LATLON    
} from '../actions/weekdayWeekendActions';

const initialState = {
    weekdayWeekendIsRefreshing: false,    
};

export function weekdayWeekend(state = initialState, action) {
    switch (action.type) {  
        
        case GET_WEEKDAY_WEEKEND_BY_LATLON.pending:
        {
            return {
                ...state,                
                weekdayWeekendIsRefreshing: true
            };
        }

        case GET_WEEKDAY_WEEKEND_BY_LATLON.fulfilled:
        {
            return {
                ...state,
                weekdayWeekend: action.payload,
                lastError: {},
                weekdayWeekendIsRefreshing: false
            };
        }

        case GET_WEEKDAY_WEEKEND_BY_LATLON.rejected:
        {
            return {
                ...state,
                weekdayWeekend: undefined,
                lastError: action.payload,
                weekdayWeekendIsRefreshing: false
            };
        }        
    }

    return state;
}